import { connect } from 'react-redux';
import { InviteDoctorForm as InviteDoctorFormView } from './InviteDoctorForm';
import { inviteDoctorFormSelector } from './selector';
import * as Actions from './actions';

const mapStateToProps = state => {
    const inviteDoctorFormState = inviteDoctorFormSelector(state);
    return {
        ...inviteDoctorFormState,
    };
};

const mapDispatchToProps = {
    onBlurDoctorsEmail: Actions.inputDoctorsEmail,
    onBlurFirstName: Actions.inputFirstName,
    onBlurLastName: Actions.inputLastName,
    onClickSend: Actions.submitForm,
    onClickFindAnotherDoctor: Actions.clickFindAnotherDoctor,
};

export const InviteDoctorForm = connect(mapStateToProps, mapDispatchToProps)(InviteDoctorFormView);
